import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DatePipe } from '@angular/common';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { ErrorHandlerDirective } from './directives/error-handler.directive';
import { authInterceptorProviders } from './auth.interceptor';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { CommonRestService } from './services/CommonRest.service';
import { BusinessCommonService } from './services/business-common.service';
import { HttpInterceptorService } from './core/interceptor/httpinterceptor-service';
import { MenuTranslationInterceptor } from './core/interceptor/menu-translation.interceptor';
import { TranslatingToastrService } from './core/i18n/translating-toastr.service';
import { SequentialTranslationService } from './core/i18n/sequential-translation.service';
import { AppCookieService, LoaderComponent, TranslationService } from '@ace/ace';
import { ExportCardComponent } from '@ace/ace';
import { NotificationsComponent } from '@ace/ace';
import { SecurityModule } from '@ace/ace';
import { environment } from '../environments/environments';
import { ACE_MAIN_NAV_PAGES, APP_ENVIRONMENT } from '@ace/ace';
import mainPages from './config/main-pages.json';

export function HttpLoaderFactory(http: HttpClient) {
  const langPath = "./assets/i18n/translation_";
  return new TranslateHttpLoader(http, langPath, '.json');
}
@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    FormsModule,
    BrowserModule,
    AppRoutingModule,
    LoaderComponent,
    HttpClientModule,
    NotificationsComponent,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    TranslateModule.forRoot({
      defaultLanguage: environment.constants.defaultLanguage,
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    TranslateModule,
    ExportCardComponent,
    SecurityModule
  ],
  providers: [
    authInterceptorProviders,
    CommonRestService,
    BusinessCommonService,
    AppCookieService,
    ErrorHandlerDirective,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (menuTranslation: MenuTranslationInterceptor) => () => menuTranslation.register(),
      deps: [MenuTranslationInterceptor],
      multi: true,
    },
    { provide: ToastrService, useClass: TranslatingToastrService },
    { provide: TranslationService, useClass: SequentialTranslationService },
    { provide: APP_ENVIRONMENT, useValue: environment },
    { provide: ACE_MAIN_NAV_PAGES, useValue: mainPages },
    DatePipe, provideAnimationsAsync()],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }
